import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

/**
 * 成本試算列表。query 只收 keyword／sort／page／page_size（其他 key 回 400 INVALID_SEARCH_FIELD）。
 * sort 白名單 name／updated_at，預設 `updated_at,desc`。
 *
 * @param {object} listQuery
 */
export async function fetchCostEstimateList(listQuery) {
  const { filters: _filters, ...rest } = listQuery ?? {};
  const { data: raw } = await request.get('/crm/cost-estimates', {
    params: listQueryToApiParams({ ...rest, filters: {} }),
  });
  return parseVer4ListResponse(raw);
}
